import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormControl, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ButtonComponent, ButtonVariant, TextareaComponent } from "@sxm-content-creators/tools-ds";
import { FORM_CONSTRAINTS } from "../interactive-form/interactive-form.validators";

export interface EditPollOptionModalData {
    /** 0-based position in the poll options list */
    index: number;
    text: string;
}

@Component({
    selector: "app-edit-poll-option-modal",
    templateUrl: "./edit-poll-option-modal.component.html",
    styleUrl: "./edit-poll-option-modal.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ReactiveFormsModule, TextareaComponent, ButtonComponent]
})
export class EditPollOptionModalComponent {
    readonly data = inject<EditPollOptionModalData>(MAT_DIALOG_DATA);
    private readonly dialogRef = inject(MatDialogRef<EditPollOptionModalComponent, string>);

    readonly textControl = new FormControl(this.data.text, {
        nonNullable: true,
        validators: [Validators.required]
    });

    update(): void {
        if (this.textControl.invalid) return;
        this.dialogRef.close(this.textControl.value);
    }

    close(): void {
        this.dialogRef.close();
    }

    protected readonly textMaxLength = FORM_CONSTRAINTS.pollOptions.textMaxLength;
    protected readonly ButtonVariant = ButtonVariant;
}
